import React, { useState } from "react";

const ServiceCard = ({ service }) => {
    const [showModal, setShowModal] = useState(false);

    const handleLearnMore = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleInquire = () => {
        window.location.href = `https://wa.me/916354311491?text=I%20want%20to%20know%20more%20about%20${service.title}`;
    };

    return (
        <div
            style={{
                border: "1px solid #e0e0e0",
                borderRadius: "12px",
                padding: "20px",
                width: "300px",
                backgroundColor: "#ffffff",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.05)",
                textAlign: "center",
                transition: "transform 0.2s, box-shadow 0.2s",
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.1)";
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.05)";
            }}
        >
            <h3
                style={{
                    fontSize: "22px", // Increased font size
                    fontWeight: "700", // Bold font weight
                    color: "#2c3e50",
                    marginBottom: "10px",
                }}
            >
                {service.title}
            </h3>
            <p style={{ fontSize: "15px", color: "#2f4f4f", marginBottom: "15px", lineHeight: "1.5" }}>
                {service.description}
            </p>
            <ul
                style={{
                    textAlign: "left",
                    listStyleType: "none",
                    padding: 0,
                    margin: "0 0 20px 0",
                    color: "#34495e",
                }}
            >
                {service.features.map((feature, index) => (
                    <li key={index} style={{ marginBottom: "8px", fontSize: "14px" }}>
                        ✔️ {feature}
                    </li>
                ))}
            </ul>
            <button
                onClick={handleLearnMore}
                style={{
                    backgroundColor: "turquoise",
                    color: "#ffffff",
                    border: "none",
                    padding: "10px 15px",
                    borderRadius: "5px",
                    cursor: "pointer",
                    marginBottom: "10px",
                    fontSize: "14px",
                    width: "100%",
                    transition: "background-color 0.2s",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#27ae60")}
                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "turquoise")}
            >
                Learn More
            </button>
            <button
                onClick={handleInquire}
                style={{
                    backgroundColor: "#3498db",
                    color: "#ffffff",
                    border: "none",
                    padding: "10px 15px",
                    borderRadius: "5px",
                    cursor: "pointer",
                    fontSize: "14px",
                    width: "100%",
                    transition: "background-color 0.2s",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#2980b9")}
                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#3498db")}
            >
                Inquire About This Service
            </button>

            {/* Modal */}
            {showModal && (
                <div
                    style={{
                        position: "fixed",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        backgroundColor: "#fff",
                        padding: "20px",
                        borderRadius: "12px",
                        boxShadow: "0 6px 12px rgba(0, 0, 0, 0.15)",
                        zIndex: 1000,
                        width: "320px",
                        textAlign: "left",
                    }}
                >
                    <button
                        onClick={handleCloseModal}
                        style={{
                            position: "absolute",
                            top: "10px",
                            right: "10px",
                            backgroundColor: "transparent",
                            border: "none",
                            fontSize: "18px",
                            fontWeight: "bold",
                            color: "#7f8c8d",
                            cursor: "pointer",
                        }}
                    >
                        ✖
                    </button>
                    <h3 style={{ fontSize: "1.5rem", color: "#2c3e50", marginBottom: "10px" }}>
                        {service.title}
                    </h3>
                    <p style={{ fontSize: "14px", color: "#7f8c8d", lineHeight: "1.6" }}>
                        {service.details}
                    </p>
                </div>
            )}

            {/* Modal Background Overlay */}
            {showModal && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.3)",
                        zIndex: 999,
                    }}
                    onClick={handleCloseModal}
                ></div>
            )}
        </div>
    );
};

export default ServiceCard;
